import { graphql, useStaticQuery } from "gatsby";
import { DomainPathQuery } from "../../graphql-types";

export default function useDomainPath() {
  const { home } = useStaticQuery<DomainPathQuery>(graphql`
    query DomainPath {
      home {
        domain {
          path
        }
      }
    }
  `);

  return home?.domain.path;
}
